export default defineNuxtPlugin({
  name: "app-status",
  dependsOn: ["heyapi"],
  async setup() {
    if (import.meta.server) {
      const { check } = useAppStatus();
      await check(clientApplicationHeader(), appLocale());
    }
  },
});
